<template>
  <div>
    <h1>{{ $t("passwordChangeByLink.title") }}</h1>
    <v-form lazy-validation ref="form" v-model="isValid" @submit="save">
      <v-text-field :label="$t('passwordChangeByLink.company')" readonly v-model="company" />
      <v-text-field :label="$t('passwordChangeByLink.alias')" readonly v-model="alias" />
      <v-text-field :label="$t('passwordChangeByLink.login')" readonly v-model="login" />
      <v-text-field :label="$t('passwordChangeByLink.password') + '*'" :rules="rules.passwordRules" type="password" v-model="password" />
      <v-text-field :label="$t('passwordChangeByLink.repeatPassword') + '*'" :rules="rules.repeatPasswordRules" type="password" v-model="passwordRepeat" />
      <v-btn :disabled="!isValid || $store.getters['Ajax/loading']" @click="save" color="success">{{ $t("passwordChangeByLink.changePasswordButton") }}</v-btn>
    </v-form>
  </div>
</template>

<script>
import { passwordRules } from "../../../models/user";
import _ from "lodash";

export default {
  name: "ActionByLinkUserPasswordChangeView",
  data: () => ({
    login: "",
    company: "",
    alias: "",
    isValid: true,
    password: null,
    passwordRepeat: null,
    passwordError: null,
    passwordValidated: false
  }),
  watch: {
    company() {
      this.validatePassword();
    },
    password() {
      this.validatePassword();
    }
  },
  created() {
    this.axios.get("/token/user/get-current", { params: { token: this.$route.params.token } }).then(resp => {
      this.login = resp.data.login;
      this.company = resp.data.company;
      this.alias = resp.data.alias;
    });
  },
  methods: {
    save() {
      if (this.$refs.form.validate() && this.passwordValidated === true && this.passwordError === null) {
        let result = this.$store.dispatch("confirmDialog", {
          content: this.$t("global.saveConfirm.content"),
          title: this.$t("global.saveConfirm.title")
        });
        result.then(() => {
          this.axios.post("token/user/save-new-password", { password: this.password, token: this.$route.params.token }).then(() => {
            this.$router.push("/action-by-link/" + this.$route.params.token);
          });
        });
      }
    },
    validatePassword: _.throttle(
      function() {
        this.passwordValidated = false;
        this.axios.post("auth/validate-password-complexity", { password: this.password, company: this.company }).then(resp => {
          this.passwordError = null;
          if (typeof resp.data.status !== "undefined" && resp.data.status === "OK") {
            this.passwordValidated = true;
          } else if (typeof resp.data.error !== "undefined") {
            this.passwordError = resp.data.error;
          }
        });
      },
      1000,
      { leading: false }
    )
  },
  computed: {
    passwordErrorMessage() {
      if (this.passwordError === null) {
        return true;
      }
      return this.$t("user.validation." + this.passwordError);
    },
    rules() {
      let temp = this;
      let rules = {
        passwordRules: passwordRules,
        repeatPasswordRules: [v => v === temp.password || temp.$t("user.validation.repeatPassword")]
      };
      if (this.passwordErrorMessage !== true) {
        rules.passwordRules = [this.passwordErrorMessage];
      }

      return rules;
    }
  }
};
</script>

<style scoped></style>
